export default __webpack_public_path__ + "static/media/SamsungS9.4edf6ec8.png";